import { render, staticRenderFns } from "./AppNavigationBoardCategory.vue?vue&type=template&id=5c97da5e&"
import script from "./AppNavigationBoardCategory.vue?vue&type=script&lang=js&"
export * from "./AppNavigationBoardCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports